import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=70619536&scoped=true"
import script from "./AuthLayout.vue?vue&type=script&lang=ts"
export * from "./AuthLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70619536",
  null
  
)

export default component.exports